import React from "react";
import {convertToDurationString} from "helpers/TimeHelpers";

import "./VideoControls.css"

const VOLUME_ICONS = [
  "control_icons/volumeoff.svg",
  "control_icons/volumequite.svg",
  "control_icons/volume1.svg",
  "control_icons/volume2.svg",
  "control_icons/volume3.svg"
];

const VOLUME_INPUT_ID = "video-volume";
const VOLUME_TOOLTIP_ID = "video-volume-tooltip";
const VOLUME_BUTTON_ID = "video-volume-button";

const CC_BUTTON_SVG = (
// Disabling eslint for this, as it is imported code from an svg file
// eslint-disable-next-line
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.45 93.67"><defs><style>{'.cls-1{fill:#fff}'}</style></defs><title>closecaptioned</title><path className="cls-1" d="M1.78,17.17v93.66H126.22V17.17Zm112.89,47c0,3.57-.17,7.5-.41,14.27-.37,10.09-3.29,15-10.89,17.23C99.6,96.73,87,97.85,78.24,97.85H49.76c-13,0-21.65-1.06-25.55-2.34C15.74,92.73,14.32,86.78,13.74,79c-.52-7.09-.42-11.36-.41-15.15,0-3.57.17-7.5.41-14.27.37-10.09,3.29-15,10.89-17.23,3.77-1.1,16.36-2.22,25.13-2.22H78.24c13,0,21.65,1.06,25.55,2.34,8.47,2.78,9.89,8.73,10.47,16.49C114.78,56.07,114.68,60.34,114.67,64.13Z" transform="translate(-1.78 -17.17)"/><path className="cls-1" d="M63.49,71.08a25.29,25.29,0,0,1-2.4,7A19.19,19.19,0,0,1,57,83.53,18.13,18.13,0,0,1,51.18,87a20.54,20.54,0,0,1-7.25,1.23,22.72,22.72,0,0,1-8.31-1.51A17.74,17.74,0,0,1,29,82.23a21.73,21.73,0,0,1-4.42-7.42,30.07,30.07,0,0,1-1.6-10.3A34.07,34.07,0,0,1,24.4,54.15a22.09,22.09,0,0,1,4.2-7.8,18.37,18.37,0,0,1,6.67-4.89,21.81,21.81,0,0,1,8.79-1.71A22.37,22.37,0,0,1,51.76,41a18.37,18.37,0,0,1,6,3.49,16.8,16.8,0,0,1,4,5.23,18.87,18.87,0,0,1,1.82,6.43H54a10.64,10.64,0,0,0-3.69-6.05A9.7,9.7,0,0,0,44.13,48q-6,0-8.75,4.28T32.57,64q0,7.59,2.77,11.79A9.28,9.28,0,0,0,43.65,80a9.83,9.83,0,0,0,6.81-2.29A12.09,12.09,0,0,0,54,71.08Z" transform="translate(-1.78 -17.17)"/><path className="cls-1" d="M105.07,71.08a25.61,25.61,0,0,1-2.39,7,19.4,19.4,0,0,1-4.14,5.41A17.91,17.91,0,0,1,92.76,87a20.54,20.54,0,0,1-7.25,1.23,22.8,22.8,0,0,1-8.31-1.51,17.74,17.74,0,0,1-6.67-4.51,21.55,21.55,0,0,1-4.41-7.42,30.06,30.06,0,0,1-1.61-10.3A34.07,34.07,0,0,1,66,54.15a22.11,22.11,0,0,1,4.21-7.8,18.28,18.28,0,0,1,6.67-4.89,21.81,21.81,0,0,1,8.79-1.71A22.31,22.31,0,0,1,93.34,41a18.26,18.26,0,0,1,6,3.49,16.68,16.68,0,0,1,4,5.23,18.85,18.85,0,0,1,1.81,6.43H95.56a10.59,10.59,0,0,0-3.69-6.05A9.66,9.66,0,0,0,85.72,48q-6,0-8.76,4.28T74.16,64q0,7.59,2.77,11.79A9.26,9.26,0,0,0,85.24,80,9.82,9.82,0,0,0,92,77.68a12,12,0,0,0,3.52-6.6Z" transform="translate(-1.78 -17.17)"/></svg>
);

export default class VideoControls extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {showVolume: false};
  }

  componentDidMount () {
    window.addEventListener("click", this.handleVolumeShow);
  }

  componentWillUnmount () {
    window.removeEventListener("click", this.handleVolumeShow);
  }

  handleVolumeShow = (e) => {
    let targetId = e.target.id;
    let {showVolume} = this.state;
    if (targetId === VOLUME_BUTTON_ID) {
      this.setState({showVolume: !showVolume});
    } else if (showVolume && (targetId !== VOLUME_INPUT_ID &&
      targetId !== VOLUME_TOOLTIP_ID)) {
      this.setState({showVolume: false});
    }
  }

  render () {
    let {handleControls,
      data,
      resume,
      showControls,
      playMode,
      handleHoveringControls,
      fullScreenEnabled,
      downloadable,
      videoURL,
      scrubbing} = this.props;
    let {showVolume} = this.state;
    let cls = "controls";
    if (!showControls && data.get("playing")) {
      cls = cls + " hidden";
    }
    let downloadURL = videoURL.replace("/vod/dl.php/", "/api/v1/api/assets/download/");
    let current = data.get("currentTime") || 0;
    let duration = data.get("duration") || 0;
    let volume = data.get("volume") || "0";
    let playButtonLabel = (data.get("playing") || resume)
      ? "control_icons/pausebutton.svg"
      : "control_icons/playbutton.svg";
    let volumeButtonIcon = "";
    let volumeLevel = Math.ceil(parseFloat(volume) / 0.25);
    if (volumeButtonIcon >= 0 && volumeButtonIcon < VOLUME_ICONS.length) {
      volumeButtonIcon = VOLUME_ICONS[volumeLevel];
    }

    let progressFallbackWidth = Math.floor((current / duration) * 100) + "%";

    let captionMode = (data.get("textTracks") &&
      data.get("textTracks").length > 0 &&
      data.get("textTracks")[0] &&
      data.get("textTracks")[0].cues &&
      data.get("textTracks")[0].cues.length > 0)
      ? data.get("textTracks")[0].mode
      : null;

    let progressDotStyle = {};
    if (duration !== 0) {
      progressDotStyle = {left: `calc(${(current / duration) * 100}% - 0.5em)`};
    }

    let volumeTooltipCls = showVolume ? "show" : "";

    let progressLabel = "";
    let progressCls = ""
    if (playMode === "live") {
      progressLabel = "Live";
      current = undefined;
      progressDotStyle = {display: 'none'}
      progressCls = "live"
    } else {
      progressLabel = parseDuration(current, duration);
    }

    return (
      <ul id='video-controls'
        className={cls}
        onMouseOver={(e) => { handleHoveringControls(true); }}
        onMouseOut={(e) => { handleHoveringControls(false); }}>
        <li className='video-control-btn'>
          <button type='button' id='video-play' onClick={handleControls}>
            <img src={playButtonLabel} className='control-btn-icon' alt="Play"/>
          </button>
        </li>
        <li className='video-control-progress'>
          <div id='video-progress-container' onMouseDown={handleControls}>
            <progress id='video-progress' className={progressCls} value={current} max={duration}>
              <span id='video-progress-fallback' style={{width: progressFallbackWidth}} />
            </progress>
            <div id='video-progress-dot' style={progressDotStyle}>
              <div id='video-progress-popup' className={scrubbing ? "mobileShow" : ""}>
                {parseDuration(current, duration)}
              </div>
            </div>
          </div>
          <span id='video-progress-label'>{progressLabel}</span>
        </li>
        <li className='video-control-volume'>
          <div id='video-volume-formatter' />
          <button type='button' id='video-volume-button'>
            <img src={volumeButtonIcon} className='control-btn-icon' alt="Volume"/>
          </button>
          <div id='video-volume-tooltip' className={volumeTooltipCls} tabIndex={1}>
            <input id='video-volume'
              type='range'
              max='1.0'
              min='0.0'
              step='0.01'
              value={volume}
              onChange={handleControls} />
          </div>
        </li>
        {fullScreenEnabled ? (<li className='video-control-btn'>
          <button type='button' id='video-fullscreen' onClick={handleControls}>
            <img src='control_icons/fullscreenopen.svg' className='control-btn-icon' alt="Fullscreen"/>
          </button>
        </li>) : ""}
        {captionMode ? (<li className='video-control-btn'>
          <button type='button' id='video-captions' onClick={handleControls}>
            <svg className={`control-btn-icon ${captionMode}`}>
              {CC_BUTTON_SVG}
            </svg>
          </button>
        </li>) : ""}
        {downloadable ? (<li className='video-control-btn'>
          <a href={downloadURL} target='_blank' rel="noopener noreferrer" download>
            <button type='button' id='video-download' onClick={handleControls}>
              <img src='control_icons/download.svg' className='control-btn-icon' alt='Download'/>
            </button>
          </a>
        </li>) : ""}
        <li className='video-chrome-btn'>
          <google-cast-launcher />
        </li>
      </ul>
    );
  }
}

function parseDuration (current, duration) {
  let currentString = convertToDurationString(current);
  let durationString = convertToDurationString(duration);
  let cur = currentString.split(":");
  let dur = durationString.split(":");
  while (dur.length > cur.length) {
    cur.unshift("");
  }
  cur = cur.map((time, index) => {
    let digits = dur[index].length;
    return time.padStart(digits, "0");
  });
  currentString = cur.join(":");
  return `${currentString} / ${durationString}`;
}
